WiseMetering.Views.NewInvoice = WiseMetering.Views.Modal.Save.extend({
    template: 'templates/invoices/new',
    className: 'mbx-info text-left',
    form_prefix: 'invoice',
    title: () => i18next.t('modal.title.invoices.new'),

    ui: {
        consumption: 'input#invoice-consumption',
        cost: 'input#invoice-cost',
        start: 'input#invoice-start',
        finish: 'input#invoice-finish',
        uploadFile: '#upload-file'
    },

    events: {
        'change input#invoice-start': 'onChangeStart'
    },

    afterSave: function() {
        if (this.model.file) {
            let formData = new FormData();
            formData.append('file', this.model.file);
            this.collection.get(this.model.id).uploadFile(formData).fail(response => {
                const message = WiseMetering.utils.uploadErrorMessage(response, body => body?.errors?.file, i18next.t('invoices.failed_to_update'));
                WiseMetering.layout.showTipper('error', message, 5000);
            });
        }
    },

    getFormData() {
        let data = this.formSerializer();

        if (this.model.unit() === 'kWh') {
            data.consumption = data.consumption * 1000;
        }

        this.model.file = this.ui.uploadFile.prop('files')[0];

        return data;
    },

    onChangeStart() {
        let start = moment(this.ui.start.val()),
            finish;

        if (start.date() === 1) {
            finish = start.endOf('month').format('YYYY-MM-DD');
        } else {
            finish = new Date(start.year(), start.month() + 1, start.date() - 1);
        }

        this.ui.finish.datepicker('setDate', finish);
    },

    onRender: function() {
        this.ui.start.datepicker(this._datePickerAttributes());
        this.ui.finish.datepicker(this._datePickerAttributes());
        this.ui.cost.attr('placeholder', i18next.t('invoices.please_insert_cost', { currency: WiseMetering.getCurrency() }));
        this.ui.consumption.attr('placeholder', i18next.t('invoices.please_insert_consumption', { unit: this.model.unit() }));
    },

    _datePickerAttributes: function() {
        return {
            dateFormat: 'yy-mm-dd',
            changeDay: true,
            changeMonth: true,
            changeYear: true
        };
    }
});
